<template>
  <component
    :is="comp"
    :editor="props.editor"
  />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue';
import { InlineMediaType } from '@superthread-com/extension-inline-media/src/index';
import type EditorService from '@/services/EditorService';

const props = defineProps<{
  type: InlineMediaType;
  editor: EditorService;
}>();

const comp = computed(() => {
  if (props.type === InlineMediaType.Video) {
    return defineAsyncComponent(() => import(/* webpackChunkName: "genericMedia" */ './Video.vue'));
  } else {
    return defineAsyncComponent(() => import(/* webpackChunkName: "genericMedia" */ './File.vue'));
  }
});
</script>

<style lang="scss">
.generic-media-file-wrapper {
  border: 1px solid white;
  border-radius: 4px;
  background-color: rgba(119, 119, 119, 0.383);
}
</style>
